import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { TextField, makeStyles } from "@material-ui/core";
import { selectMessage, set } from "./messageSlice";

import { selectLanguage } from "../language/languageSlice";
const useStyles = makeStyles((theme) => ({
  root: {
    "& > *": {
      margin: theme.spacing(1),
      width: "100%",
      "&:hover": {
        borderBlockColor: "rgba(255,0,0,1)",
        borderColor: "rgba(255,0,0,1)",
        boxShadow: "0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23)",
      },
      transition: "box-shadow 0.75s",
    },
  },
}));

export function Message() {
  const classes = useStyles();
  const msgValue = useSelector(selectMessage);
  const language = useSelector(selectLanguage);
  const dispatch = useDispatch();
  // const [incrementAmount, setIncrementAmount] = useState("2");

  return (
    <form className={classes.root} noValidate autoComplete="off">
      <TextField
        id="input-message"
        label={
          language !== undefined
            ? language === "TH"
              ? "ข้อความ"
              : "Messages"
            : "Messages"
        }
        color="secondary"
        placeholder={
          language !== undefined
            ? language === "TH"
              ? "ข้อความ"
              : "Messages"
            : "Messages"
        }
        variant="outlined"
        rows={5}
        multiline
        value={msgValue}
        onChange={(e) => {
          if (e.target.value.length <= 2000) {
            dispatch(set(e.target.value));
          }
        }}
      />{" "}
    </form>
  );
}
